import React from 'react';
import SymbolGallery from '../components/analysts/SymbolGallery';

export default function SymbolsPage() {
  return (
    <div className="p-4 md:p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Symbols</h1>
        <p className="text-sm text-gray-500 mt-1">
          Symbols tracked by our analyst network, ranked by coverage.
        </p>
      </div>
      <SymbolGallery />
    </div>
  );
}
